import { euroFormat } from './price'

export const eur = (val: any) => {
  if (!val && val !== 0) {
    return '- €'
  }
  if (val === 0) {
    return '0 €'
  }
  if (typeof val === 'string' && val.includes('.')) {
    return euroFormat.format(parseFloat(val)).replace(/,00/g, '')
  }
  else if (typeof val === 'number') {
    return euroFormat.format(val).replace(/,00/g, '')
  }
  else {
    return val + ' €'
  }
}
